export default "__VITE_ASSET__Bnt6Qg7A__"